import React from 'react';
import { IMAGES, tomes } from '../data/site';
import { SectionCta } from './SectionCta';
export function SystemSection() {
  return <section className="w-full bg-navy-deep px-5 py-14 sm:px-6 sm:py-20" data-id="element-291" data-mp="3gihpbm3cc2sl">
      <div className="mx-auto max-w-3xl text-center" data-id="element-292" data-mp="3bi3nwmw8vr3j">
        <h2 className="font-serif text-[28px] font-bold leading-[1.12] text-cream sm:text-4xl" data-id="element-293" data-mp="3bkpzcxm9aqr1">
          You don’t get one PDF.
          <span className="mt-2 block text-gold-light" data-id="element-294" data-mp="31l8vmlqkemxp">You get an entire clinical decision system.</span>
        </h2>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-295" data-mp="2wsxsla0j2l0x">
          {tomes.map(tome => <li key={tome.numeral} className="flex items-center gap-3 rounded-xl bg-white/[0.06] px-4 py-3 ring-1 ring-inset ring-white/10" data-id="element-296" data-mp="2st6vkoker8ny">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-serif text-[13px] font-bold text-white" style={{
            backgroundColor: tome.accent
          }} data-id="element-297" data-mp="2iuhdauolnm76">
                {tome.numeral.replace('Tome ', '')}
              </span>
              <span className="text-[14px] font-semibold leading-snug text-cream" data-id="element-298" data-mp="18q6fedh3zsva">{tome.title}</span>
            </li>)}
        </ul>

        <div className="-mx-2 mt-9 sm:mx-0" data-id="element-299" data-mp="u2v5eg0ksgxa">
          <img src={IMAGES.mainMockup} alt="All six tomes and five bonuses of the Menopause Decision Desk™ shown together" className="mx-auto w-full max-w-xl" data-id="element-300" data-mp="yzln17s13kkt" />
        </div>

        <p className="mt-2 font-serif text-[20px] font-bold leading-snug text-gold-light sm:text-2xl" data-id="element-301" data-mp="1rnr7ruj319kn">
          Together, they create the Menopause Decision Desk™
        </p>

        <div className="text-left" data-id="element-302" data-mp="1hq39wvq6jly9">
          <SectionCta headline="One complete desk instead of a folder full of downloads." label="Claim the complete desk" variant="gold" data-id="element-303" data-mp="1hp1mdrrz96zn" />
        </div>
      </div>
    </section>;
}